export function getTitleLines(title: string): string[] {
	const titleWords = title.split(" ");
	const titleWordsPerLine = titleWords.length === 3 ? 2 : titleWords.length % 2 !== 1 ? 2 : 3;
	const titleLines: string[] = [];
	for (
		let titleWordIndex = 0;
		titleWordIndex < titleWords.length;
		titleWordIndex += titleWordsPerLine
	) {
		titleLines.push(
			titleWords.slice(titleWordIndex, titleWordIndex + titleWordsPerLine).join(" ") + " ",
		);
	}
	titleLines[titleLines.length - 1] = titleLines[titleLines.length - 1].trimEnd();
	return titleLines;
}
